import React from 'react';
import './Skills.css';

function Skills() {
  return (
    <section id="skills"className="skills-section">
      <div className="ttle">
        <h1>Skills</h1>
      </div>
      <div className="skills-circle-wrap">
        <div className="skills-circle">
          <div className="skill-orbit">
            <div className="skill-planet"><span>JS</span></div>
          </div>
          <div className="skill-orbit">
            <div className="skill-planet"><span>CSS</span></div>
          </div>
          <div className="skill-orbit">
            <div className="skill-planet"><span>HTML</span></div>
          </div>
          <div className="skill-orbit">
            <div className="skill-planet"><span>AI</span></div>
          </div>
          <div className="skill-orbit">
            <div className="skill-planet"><span>PS</span></div>
          </div>
        </div>
        <div className="skills-top-circle"></div>
      </div>
    </section>
  );
}

export default Skills;
